import React from "react";
import { Box, CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme, alpha } from "@mui/material/styles";
import { Navbar } from "./Components/Navbar";
import { HeroSection } from "./Components/HeroSection";
import { FeaturesSection } from "./Components/FeaturesSection";
import { Footer } from "./Components/Footer";

// Tema Amarelo/Laranja vibrante
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#FFC107", // Amarelo Âmbar
      dark: "#FFA000",
      light: "#FFD54F",
      contrastText: "#212121",
    },
    secondary: {
      main: "#FF7043", // Laranja Coral
      dark: "#F4511E",
      light: "#FF8A65",
      contrastText: "#ffffff",
    },
    background: {
      default: "#FFF8E1", // Amarelo muito claro
      paper: "#FFFFFF",
    },
    text: {
      primary: "#424242",
      secondary: "#757575",
    },
    divider: alpha("#424242", 0.12),
  },
  typography: {
    fontFamily: '"Montserrat", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 600,
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          padding: "8px 22px",
          boxShadow: `0 2px 10px ${alpha("#000", 0.08)}`,
        },
        containedPrimary: {
          color: "#212121",
          "&:hover": {
            backgroundColor: "#FFA000",
            boxShadow: `0 4px 15px ${alpha("#FFC107", 0.3)}`,
          },
        },
        containedSecondary: {
          "&:hover": {
            backgroundColor: "#F4511E",
            boxShadow: `0 4px 15px ${alpha("#FF7043", 0.3)}`,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: `0 2px 12px ${alpha("#9E9E9E", 0.1)}`,
        },
      },
    },
  },
});

export const LandingPages0005 = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: theme.palette.background.default,
        }}
      >
        <CssBaseline />
        <Navbar />
        <HeroSection />
        <FeaturesSection />
        <Footer />
      </Box>
    </ThemeProvider>
  );
};
